module.exports = __webpack_public_path__ + "static/media/start-registry-graphic.52cd5e83.svg";